/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_IntroInputs */

const es_privacy_policy_sharing_intro = /** @type {(inputs: Privacy_Policy_Sharing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartimos su informacion solo en circunstancias limitadas:`)
};

const en_privacy_policy_sharing_intro = /** @type {(inputs: Privacy_Policy_Sharing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We share your information only in limited circumstances:`)
};

/**
* | output |
* | --- |
* | "We share your information only in limited circumstances:" |
*
* @param {Privacy_Policy_Sharing_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_intro = /** @type {((inputs?: Privacy_Policy_Sharing_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_intro(inputs)
	return en_privacy_policy_sharing_intro(inputs)
});
export { privacy_policy_sharing_intro as "privacy_policy.sharing.intro" }